export default {"src":"/_next/static/media/member-using-app.mono.d3a23f3d.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};